import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },
    "Jardín La Pradera": { initFrame:  110 },
    "Oratorio": { initFrame:  90 },
    "Club La Rivera": { initFrame:  115 },
    "Spa": { initFrame:  115 },
    "Área de piscina": { initFrame:  115 },
    "Circuito deportivo": { initFrame:  5 },
    "Área de Parques": { initFrame:  75 },
    "Club Deportivo Rivera": { initFrame:  50 },
    //"EveryTransition": { importTransition: AllTransitions }
}
